import React from "react";
import InvoiceForm from "./InvoiceForm";
import api from "../../api";
import { useTranslation } from "react-i18next";
import { FaFileInvoice } from "react-icons/fa";

const InvoiceEditModal = ({ open, onClose, invoice }) => {
  const { t } = useTranslation();

  const handleSave = async (formData) => {
    try {
      if (invoice && invoice.id) {
        await api.put(`/invoices/${invoice.id}`, formData);
      } else {
        await api.post("/invoices", formData);
      }
      onClose();
    } catch (err) {
      alert(t("invoice.saveError"));
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal panel */}
      <div className="relative z-10 bg-base-100 rounded-2xl border border-base-200 shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-base-200 sticky top-0 bg-base-100 z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
              <FaFileInvoice className="text-sm" />
            </div>
            <h2 className="text-lg font-bold text-base-content">
              {invoice ? t("invoice.editTitle") : t("invoice.newTitle")}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="btn btn-ghost btn-sm btn-square text-base-content/40 hover:text-base-content"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <InvoiceForm
            invoice={invoice}
            onSave={handleSave}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceEditModal;
